// Wraps the google maps places API

import auth from '../auth'
import http from '../http'

export default {
  autocomplete: function (input) {
    return http.get('/places/autocomplete/', auth.getAuthHeader(), {query: input}, true)
  },
  details: function (placeId) {
    return http.get('/places/place/', auth.getAuthHeader(), {place_id: placeId}, true)
  }
}
